export enum JobManualBillingEnum {
  Automatic = '1',
  Manual = '2'
}
